import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { Idioma } from '@core/models';
import { selectLanguageCurrent, selectLanguageTranslations } from '@store/selectors';
import { LanguageEnum } from '@core/enums';

@Injectable({
  providedIn: 'root',
})
export class TranslationHelper implements OnDestroy {
  currentLanguage: string = LanguageEnum.English;
  private translations: Idioma = {};

  private destroy$ = new Subject<void>();

  constructor(private store: Store) {
    this.store.select(selectLanguageCurrent)
      .pipe(takeUntil(this.destroy$))
      .subscribe((language) => {
        this.currentLanguage = language || LanguageEnum.English;
      });

    this.store
      .select(selectLanguageTranslations)
      .pipe(takeUntil(this.destroy$))
      .subscribe((translations) => {
        this.translations = translations;
      });
  }

  getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  getTranslate(key: string): string {
    return this.translations[key] || key;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
